import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sectionsActions from '../../redux/actions/sectionsActions';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as usersActions from '../../redux/actions/usersActions';

import ReviewQuestion from "../features/review/ReviewQuestion";
import ReviewHead from "../features/review/ReviewHead";

class ReviewPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // This will be false unless we're coming from the dashboard
      showFlaggedQuestionsOnly: props.location.state && props.location.state.showFlagged
    };
  }

  componentDidMount() {
    this.theseAssessmentIds.forEach(id => {
      this.props.assessmentsActions.getAssessment(id);
    })
  }

  getSection() {
    this.props.sectionsActions.getSection(this.sectionId);
  }

  getUsers() {
    // This will only run for the PDF generator, since it comes through the back door and doesn't receive users on login.
    this.props.usersActions.getUsers();
  }

  toggleFlaggedQuestions = () => {
    this.setState(prevState => ({
      showFlaggedQuestionsOnly: !prevState.showFlaggedQuestionsOnly
    }));
  }

  render() {
    const reg = /assessments\[\]=(\d*)/g;
    let match;
    this.theseAssessmentIds = [];
    while ((match = reg.exec(this.props.location.search)) !== null) {
      this.theseAssessmentIds.push(match[1]);
    }
    const theseAssessments = this.theseAssessmentIds.map(id => this.props.assessments[id]).slice(0, 3);
    if (theseAssessments.some(assessment => !assessment)) return null; // make sure we have loaded all assessments
    if (!theseAssessments.length || !theseAssessments.reduce((a, b) => (a.section === b.section) ? a : NaN)) {
      // Get out if we're trying to compare assessments from different sections or if we forgot to pass query parameters
      return <Redirect to="/assessments" />;
    }
    if (theseAssessments.some(assessment => assessment.uploaded || !assessment.dateCompleted)) {
      // Jump out for incomplete or uploaded assessments
      return <Redirect to="/assessments" />;
    }
    this.sectionId = theseAssessments[0].section;
    if (!this.props.sections[this.sectionId] || !this.props.sections[this.sectionId].questions) {
      this.getSection();
      return null;
    } else {
      this.section = this.props.sections[this.sectionId];
    }
    if (!this.props.users) {
      // We're here generating a PDF so there aren't any users in Redux yet.
      this.getUsers();
      return null;
    }
    const flaggedIds = theseAssessments.reduce((obj, {id, answers}, index) => {
        obj[id] = Object.entries(answers)
          .filter(([itemId, {flagged}]) => flagged)
          .map(([itemId, item]) => itemId);
        return obj;
      }, {})
    const allFlaggedIds = [...new Set([].concat(...Object.values(flaggedIds)))];
    const questions = this.state.showFlaggedQuestionsOnly
      ? Object.values(this.section.questions).filter(question => (
          allFlaggedIds.includes(question.id.toString())
        ))
          .sort((a, b) => a.index - b.index)
      : Object.values(this.section.questions)
          .sort((a, b) => a.index - b.index)
    const colClass = theseAssessments.length === 1
      ? 'review-detail__one-col'
      : (theseAssessments.length === 2
        ? 'review-detail__two-col'
        : 'review-detail__three-col'
        );
    const colorClass = 'color--' + this.section.theme;
    const wrapperClass = theseAssessments.length === 1
      ? 'review-detail--small'
      : (theseAssessments.length === 2
        ? 'review-detail--medium'
        : 'review-detail--large'
        );
    return (
      <div className={`review-detail ${wrapperClass}`}>
        <Helmet>
          <title>Review</title>
        </Helmet>
        <ReviewHead
          assessments={theseAssessments}
          assessmentIds={this.theseAssessmentIds}
          colClass={colClass}
          colorClass={colorClass}
          section={this.section}
          showFlaggedQuestionsOnly={this.state.showFlaggedQuestionsOnly}
          toggleFlaggedQuestions={this.toggleFlaggedQuestions}
          flaggedIds={flaggedIds}
          questions={questions}
          users={this.props.users}
        />
        <div className="review-detail__questions-wrapper">
          {questions.map(question => (
            <ReviewQuestion
              key={question.id}
              question={question}
              theseAssessments={theseAssessments}
              colClass={colClass}
              sectionTheme={this.section.theme}
              colorClass={colorClass}
            />
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    assessments: state.assessments.list,
    sections: state.sections,
    users: state.users.roster
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sectionsActions: bindActionCreators(sectionsActions, dispatch),
    assessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    usersActions: bindActionCreators(usersActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewPage);


// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage.js